import React from 'react';
import { connect } from 'react-redux';
import { selectHasSinglePinnedVariable } from '@ff-scene-plugins/gift-redux/slices/variablesSlice';
import { GiftPdpState } from '@ff-scene-plugins/gift-redux/store';
import { ColorAttributeDropdownList } from './ColorAttributeDropdownList';
import { ColorAttributeWindow } from './ColorAttributeWindow';

const _ColorAttributeDropdownMobile = ({
    renderPreview,
    variableIds,
    hasSinglePinnedVariable
}: Props) => {
    if (hasSinglePinnedVariable) {
        return <ColorAttributeDropdownList gap='xs' variableIds={variableIds} />;
    } else {
        return <ColorAttributeWindow renderPreview={renderPreview} variableIds={variableIds} />;
    }
};

type Props = {
    renderPreview: () => JSX.Element;
    variableIds: string[];
    hasSinglePinnedVariable: boolean;
};

const mapStateToProps = (state: GiftPdpState) => ({
    hasSinglePinnedVariable: selectHasSinglePinnedVariable(state)
});

export const ColorAttributeDropdownMobile = connect(
    mapStateToProps
)(_ColorAttributeDropdownMobile);